<template>
  <v-main>
    <div
      size="A4"
      layout="landscape"
      class="page-a4 container elevation-5">
      <div
        v-for="prototype in prototypeData"
        :key="prototype.id">
        <manufac-for-export-new
          v-if="isNewData(prototype)"
          :prototype="prototype" />

        <manufac-for-export
          v-else
          :prototype="prototype" />
      </div>
    </div>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ManufacForExport from '../components/ManufacForExport.vue'
import ManufacForExportNew from '../components/ManufacForExportNew.vue'
import FabricsProvider from '@/resources/FabricsProvider'

export default {
  components: {
    ManufacForExport,
    ManufacForExportNew
  },
  data () {
    return {
      fabricService: new FabricsProvider(),
      prototypeData: []
    }
  },
  computed: {
    ...mapGetters({
      prototypes: 'Prototypes/prototypes'
    })
  },
  async mounted () {
    this.setLoading({
      active: true,
      clickAble: false,
      message: 'Loading...'
    })
    this.prototypeData = [...this.prototypes]
    await this.setLoading({
      active: false,
      clickAble: false,
      message: 'Loading...'
    })
    window.print()
  },
  methods: {
    ...mapActions({
      setLoading: 'Components/setLoading'
    }),
    isNewData (prototype) {
      return 'colors' in prototype.order
    }
  }
}
</script>

<style lang="scss">
div[size="A4"][layout="landscape"] {
  display: block;
  width: 297mm;
  min-height: 210mm;
  margin: 10px auto;
  padding: calc(12.7mm - 24px);
  background-color: #ffffff;
  word-wrap: break-word;
  page-break-after: always;
  .col {
    position: relative;
  }
  .buttun-remove-product {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
  }
}
// #app div[size=A4] .col {
//   display: inline-block;
//   flex-basis: unset;
//   -webkit-box-flex: unset;
//   flex-grow: unset;
// }
// #app div[size=A4] .row {
//   display: block;
//   width: 100%;
// }
// #app div[size=A4] .row + .row {
//   margin-top: 0;
// }
.page-break-after {
  display: none;
}
@media print {
  .page-break {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
  .page-break-after {
    display: block;
    page-break-after: always;
  }
}
</style>
